import gql from "graphql-tag"

export const VALIDATE_LEDYER = gql`
  query validateLedyer($clientId: String!, $clientSecret: String!, $authUrl: String!, $baseUrl: String! ) {
    Configuration {
      validate {
        ledyer(clientId: $clientId, clientSecret: $clientSecret, authUrl: $authUrl, baseUrl: $baseUrl) {
          errorMessage
          valid
        }
      }
    }
  }
`
